module.exports = __webpack_public_path__ + "static/img/egg_g_18.e44e0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_18.png
// module id = dDfv
// module chunks = 1